export const MARKETING_TAG_POSITION = {
  PDP: "PDP",
  MENU_CARD: "MENU_CARD",
};

export const FILTER_TAG_LOCATION = {
  TAKEOVER: "TAKEOVER",
  NAV: "NAV",
};
